export default "__VITE_ASSET__DAKxQzPX__"